<section class="pt-3">
  <screen-support></screen-support>  
</section>

<section class="sfe-safe  sfe-welcome">
  <div class="pt-5" *ngIf="authService.userData as user">
    <h1 class="sfe-welcome-head">Welcome, {{(user.displayName) ? user.displayName : 'User | Entrepreneur'}}
    </h1>
    <p>The system to help you develop your business! You get out what you put in, let's work together to make something great.
    </p>
    <button
    *ngIf="isSuperAdmin"
    class="sfe-capitalize sfe-button-round sfe-button-blue"
    mat-raised-button
    [routerLink]="['/super-admin', 'dashboard']"
  >
    Admin List
  </button>
    <!--<div *ngIf="authService.isAdmin == false">
      <button class="sfe-capitalize sfe-button-round sfe-button-blue" mat-raised-button  routerLink="/entrep-dash"  >Dashboard</button>
    </div>
    <div *ngIf="authService.isAdmin == true">
      <button class="sfe-capitalize sfe-button-round sfe-button-blue" mat-raised-button  routerLink="/super-admin/admin-details"  >Dashboard</button>
    </div>-->
  </div>
</section>

<section class="pt-3">
  <div class="row">
    <div class="col-lg-4 col-md-4 col-sm-12 sfe-col-spacer">
      <mat-card>
        <mat-card-header>
          <div mat-card-avatar class="icon-calc"><mat-icon class="icon-calc">verified_user</mat-icon></div>
          <mat-card-title class="sfe-card-header">
            Admin Code
          </mat-card-title>
          <mat-card-subtitle>Remember to add your admin code</mat-card-subtitle>
        </mat-card-header>
        <form class="entreprener-form" *ngIf= "isShown2 && !isAdmin" autocomplete="off"> 
        <mat-card-content class="sfe-card-text">
          <!--admin code-->
        
            <mat-form-field [class.display-none]="!!adminCode && !isEntreprenerEdit" class="example-full-width" appearance="fill">
              <mat-label>Your admin code</mat-label>
              <input matInput #codeShared placeholder="Add a code" name="adminCode" required/>
            </mat-form-field>
            <div class="admin-code" *ngIf="!isEntreprenerEdit && adminCode">
              <p class="admin-code-text">
                <span>{{adminCode}}</span>
              </p>
            </div>
            <div class="space-left-added">
              <button *ngIf="isEntreprenerEdit && adminCode" mat-button color="secondary" type="reset" (click)="onSubmit2(adminCode);">Cancel</button>
              <button class="entreprener-form-submit-btn" mat-raised-button color="warn" type="submit"  [disabled]="!adminCode" (click)="!!adminCode && remove(codeShared?.value); codeShared.value = null">Remove</button>&nbsp;&nbsp;&nbsp;&nbsp;
              <button class="entreprener-form-submit-btn" mat-raised-button color="primary" type="submit"  [disabled]="!codeShared.value && isEntreprenerEdit" (click)="onSubmit2(codeShared?.value); codeShared.value = null">{{ adminCode ? 'Modify': 'Add'}}</button>
            </div>
            </mat-card-content>
          </form>

          <div *ngIf="isAdmin" class="code-generator">
            <div class="code-generator-info">
              <p class="code-generator-text">
                <span *ngIf="adminCode">Code to share : <strong [innerText]="adminCode"></strong> </span>
                <span *ngIf="!adminCode">No code is generated. Click on the next button to generate a code you can share to your clients.</span>
              </p>
            </div>
            <div class="code-generator-actions">
              <button mat-icon-button *ngIf="adminCode" title="Copy" [cdkCopyToClipboard]="adminCode"><mat-icon>content_copy</mat-icon></button>
              <button [class.space-left-added]="adminCode" mat-raised-button *ngIf="adminCode" color="accent" (click)="remove()">Remove</button>
              <div class="pt-3"></div>
              <button 
                [class.space-left-added]="adminCode"
                mat-raised-button 
                color="primary" 
                type="button" 
                [disabled]="!!adminCode"
                #submitBtn
                (click)="submitCode(!!adminCode)">
                Generate a code
              </button>
            </div>
          </div>
          <div class="pb-5"></div>

      
      </mat-card>

    </div>
    <div class="pt-3"></div>
    <div class="col-lg-8 col-md-8 col-sm-12 sfe-col-spacer">
      <mat-card class="account-card">
        <mat-card-header>
          <div mat-card-avatar class="account-header-image">
            <div *ngIf="authService.userData as user">   
              <img class="img-thumbnail rounded-circle profile-photo" src="{{(user.photoURL) ? user.photoURL : '/assets/dummy-user.png'}}" alt="profile">   
            </div>
          </div>
          <mat-card-title>
            <div *ngIf="authService.userData as user">  
              {{(user.displayName) ? user.displayName : 'User | Entrepreneur'}}
            </div>
          </mat-card-title>
          <mat-card-subtitle>
            <div *ngIf="authService.isAdmin == false">
              Entrepreneur
            </div>
            <div *ngIf="authService.isAdmin == true">
              Admin
            </div>
          </mat-card-subtitle>
        </mat-card-header>
        <!--img mat-card-image src="https://material.angular.io/assets/img/examples/shiba2.jpg" alt="Photo of a Shiba Inu"-->
        <mat-card-content>
          <p class="sfe-card-text">
            You are the person who organizes and operates your business,
            taking on greater than normal risks in order to make a difference in the world.
          </p>
        </mat-card-content>
        <mat-card-actions >
          <div *ngIf="authService.userData as user" class="d-flex">  
          <button mat-button disabled><mat-icon>edit</mat-icon> Edit Account</button>
          <!--<div *ngIf="authService.isAdmin == false">
            <button class="sfe-capitalize sfe-button-round sfe-button-rblue" mat-raised-button  routerLink="/entrep-dash"  >Dashboard</button>
          </div>
          <div *ngIf="authService.isAdmin == true">
            <button class="sfe-capitalize sfe-button-round sfe-button-rblue" mat-raised-button  routerLink="/admin-dash"  >Dashboard</button>
          </div>-->
       </div>
        </mat-card-actions>
      </mat-card>
      
    </div>
  </div>

</section>
